import script from "./PatientInformationFormPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientInformationFormPreview.vue?vue&type=script&setup=true&lang=js"

import "./PatientInformationFormPreview.vue?vue&type=style&index=0&id=4dfca64a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfca64a"]])

export default __exports__